import React from 'react';
import PortalService from '../../../services/portal/portal.service';
import { usePortalResource } from '../usePortalResource';
import PortalSection, { Card, EmptyState } from '../PortalSection';
import VisitSlotCard from './VisitSlotCard';
import { formatPortalDate } from '../format';

/** Schedule: the next 14 days (R-234 projection). */
const ScheduleScreen: React.FC<{ patientId: string }> = ({ patientId }) => {
  const { data, loading, error } = usePortalResource(PortalService.getSchedule, patientId);
  return (
    <PortalSection title="Schedule" loading={loading} error={error}>
      {data && (
        <div className="flex flex-col gap-3">
          <p className="text-sm text-slate-700">
            {formatPortalDate(data.from, false)} to {formatPortalDate(data.to, false)}
          </p>
          {data.paused && (
            <p role="status" className="rounded-md border border-amber-300 bg-amber-50 p-3 font-medium text-amber-900">
              Visits are paused
            </p>
          )}
          {data.visits.length === 0 ? (
            <EmptyState>No visits are scheduled in the next 14 days.</EmptyState>
          ) : (
            <ul className="flex flex-col gap-3">
              {data.visits.map((slot, index) => (
                <li key={`${slot.date}-${slot.windowStart}-${index}`}>
                  <Card>
                    <VisitSlotCard slot={slot} />
                  </Card>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </PortalSection>
  );
};

export default ScheduleScreen;
